<template>
  <div class="main__wrapper">
    <div class="main__panel main__panel-left">
      <conversations :theme="theme" />
    </div>
    <template v-if="activeConversation">
      <div class="main__panel main__panel-center">
        <chat :key="key" />
      </div>
      <div class="main__panel main__panel-right">
        <profile @select-client="selectClient" />
      </div>
    </template>
    <div v-else class="main__panel main__panel-center">
      <chat-empty />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { LOCALE_LAGUAGE_CHANGE } from '@/eventTypes';
import EventBus from '@/eventBus';

export default {
  components: {
    Chat: () => import('@/components/Chat.vue'),
    ChatEmpty: () => import('@/components/ChatEmpty.vue'),
    Conversations: () => import('@/components/Conversations.vue'),
    Profile: () => import('@/components/Profile.vue'),
  },
  data() {
    return {
      key: 0,
      actualClientId: '',
    };
  },
  created() {
    EventBus.$on(LOCALE_LAGUAGE_CHANGE, () => {
      this.key += 1;
      this.setActiveClient('');
    });
  },
  destroyed() {
    EventBus.$off(LOCALE_LAGUAGE_CHANGE);
  },
  computed: {
    ...mapGetters([
      'activeConversation',
      'theme',
    ]),
    client() {
      return this.activeConversation ? this.activeConversation.client ?? {} : {};
    },
    channelId() {
      return this.activeConversation?.conversation?.channel?.id;
    },
  },
  methods: {
    ...mapMutations(['setActiveClient']),
    selectClient() {
      this.actualClientId = this.client ? this.client.id ?? null : null;
      this.$modal.show('user-multimedia', {
        clientId: this.actualClientId,
        channelId: this.channelId,
      });
    },
  },
};
</script>
